import ReactOnRails from 'react-on-rails';
import App from './App.tsx';

ReactOnRails.register({ App, });
